<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'despatched-list'"
  />
</template>

<script>
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import {
  SalesOrderTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/salesorder-tabs";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      CustomerSalesRepresentativeCode: undefined,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Sales Orders",
        ScreenName: "Sales Orders - Despatched",
        selectedIndex: GetIndexByTabName("Despatched"),
        tabs: SalesOrderTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "DespatchedList",
              serverPaging: true,
              allowGrouping: false,
              select: [
                "DeliveryNoteComputedString",
                "InvoiceNoComputedString",
                "SalesOrderNoComputedString",
                "SalesOrderNo",
                "CustomerCode",
                "CustomerName",
                "BillToCustomerCode",
                "BranchCode",
                "BranchDescription",
                "DeliveryDate",
                "DeliverTo",
                "FriendlyStatus",
                "InvoiceNo",
                "DeliveryNote",
              ],
            },
            options: {
              selectionMode: "multiple",
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            multiplePdf: true,
            export: false,
            openFilter: true,
            expand: false,
            screenName: "Sales Orders - Despatched",
            filterOnEnter: true,
          },
          columns: [
            {
              screenField: "DeliveryNo",
              gridDataField: "DeliveryNoteComputedString",
              dataField: "DeliveryNoteComputedString",
              calculateSortValue: "DeliveryNote",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              filterIndex: 0,
              filterDataField: "DeliveryNote",
              type: "Integer",
              width: ColumnWidth.DeliveryNumber.width,
              minWidth: ColumnWidth.DeliveryNumber.minWidth,
            },
            {
              screenField: "Invoice",
              gridDataField: "InvoiceNoComputedString",
              label: "Invoice #",
              filterIndex: 1,
              filterDataField: "InvoiceNo",
              type: "Integer",
              width: ColumnWidth.InvoiceNumber.width,
              minWidth: ColumnWidth.InvoiceNumber.minWidth,
            },
            {
              screenField: "SalesOrder",
              gridDataField: "SalesOrderNoComputedString",
              label: "Sales Order #",
              width: ColumnWidth.SalesOrderNumber.width,
              minWidth: ColumnWidth.SalesOrderNumber.minWidth,
            },
            {
              screenField: "Code",
              filterLabel: "Sales Order",
              filterDataField: "SalesOrderNo",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 2,
            },
            {
              screenField: "Customer",
              filterIndex: 4,
            },
            {
              screenField: "BillToCustomer",
              filterDataField: "BillToCustomerCode",
              allowSearch: false,
              visible: false,
              showInColumnChooser: false,
              filterIndex: 5,
            },
            {
              screenField: "Branch",
              visible: false,
            },
            {
              screenField: "Date",
              label: "Delivery Date",
              filterLabel: "Delivery Date",
              gridDataField: "DeliveryDate",
              filterDataField: "DeliveryDate",
              filterIndex: 6,
              width: ColumnWidth.Date.width,
              minWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "DeliverTo",
              cellTemplate: undefined,
              itemTemplate: undefined,
              cellTemplateRecord: undefined,
              gridDataField: "DeliverTo",
              filterDataField: "DeliverTo",
              filterIndex: 7,
              type: "Text",
              editorTemplate: {
                primary: [
                  {
                    dataField: "CompanyName",
                  },
                ],
              },
            },
            {
              screenField: "OrderStatus",
              filterLabel: "Delivery Status",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 3,
              dataSourceConfig: {
                data: ["Cancelled", "Credited", "Invoiced", "Pending"],
              },
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoFields: [
                {
                  ReportDisplayName: "Invoice",
                  ReferenceNoField: "InvoiceNo",
                },
                {
                  ReportDisplayName: "Delivery Note",
                  ReferenceNoField: "DeliveryNote",
                },
              ],
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
              menuItems: {
                makeDisabled: (data) => {
                  var items = [];
                  var x = { ...data };

                  x.column.PrintPreview.forEach((element) => {
                    if (
                      x.data.FriendlyStatus == "Pending" &&
                      element.ScreenLayoutApplicationFeatureCode ===
                        "ReportInvoice"
                    )
                      element.disabled = true;
                    else element.disabled = false;

                    items.push({
                      ReportDisplayName: element.ReportDisplayName,
                      ScreenLayoutApplicationFeatureCode:
                        element.ScreenLayoutApplicationFeatureCode,
                      Parameters: element.Parameters,
                      disabled: element.disabled,
                    });
                  });

                  return items;
                },
              },
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoFields: [
                {
                  ReportDisplayName: "Invoice",
                  ReferenceNoField: "InvoiceNo",
                },
                {
                  ReportDisplayName: "Delivery Note",
                  ReferenceNoField: "DeliveryNote",
                },
              ],
              menuItems: {
                makeDisabled: (data) => {
                  var items = [];
                  var x = { ...data };

                  x.column.BackgroundPrint.forEach((element) => {
                    if (
                      x.data.FriendlyStatus == "Pending" &&
                      element.ReportDisplayName === "Invoice"
                    )
                      element.disabled = true;
                    else element.disabled = false;

                    items.push({
                      ReportDisplayName: element.ReportDisplayName,
                      TransactionCode: element.TransactionCode,
                      ScreenName: element.ScreenName,
                      disabled: element.disabled,
                    });
                  });

                  return items;
                },
              },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "OrderStatus" &&
        e.column.screenField != "GridRecordEmail" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordPrint" &&
        e.column.screenField != "GridRecordEllipsisMenu" &&
        e.column.type != "selection"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "delivery-note",
          mode: "review",
          idProperty: "DeliveryNote",
        });
      }
    },
  },

  created() {
    this.setLoading = true;
  },
};
</script>

<style lang="scss"></style>
